import { Fragment, useEffect } from 'react';
import { Button, Typography } from '@material-tailwind/react';
import { Cards } from '../../components/card/cards';
import CarouselNavigation from '../../components/carousel/carouselnavigation';
import IconArrayList from '../../components/iconarraylist';

import '../../styles/home/home.css';
import { Link, useNavigate } from 'react-router-dom';
import { ProductSubType } from '../../enum';
import CourseList from '../../components/course/CourseList';
import { HOME_REVIEW_DATA } from '../../data/statics-datas';
import MainBanner from '../../components/carousel/MainBanner';
import Popup from '../../components/modal/Popup';
import { PopupCategory } from '../../constants/types/popup-type';

const Home = () => {
  const navigate = useNavigate();

  const isStudent = localStorage.getItem('type') === 'STUDENT' ? true : false;

  useEffect(() => {
    if (isStudent) {
      navigate('/student');
    }
  }, []);

  return (
    <Fragment>
      <Popup categoryId={PopupCategory.MAIN} />
      {/* 메인 배너 */}
      {/* <section className="m-auto grid max-w-[1920px] place-items-center">
        <CarouselNavigation />
      </section> */}

      <section className="lg:aspect-none m-auto aspect-video w-full max-w-[1920px] lg:max-h-[423px]">
        <MainBanner />
      </section>

      <section className="m-auto mt-4 grid max-w-[1440px] px-5 lg:px-14">
        <Typography variant="h4" className="my-4 text-xl md:text-2xl">
          젭스에 오신 걸 환영합니다!
        </Typography>

        <IconArrayList />
      </section>

      <section className="m-auto mt-10 grid max-w-[1440px] px-5 md:mt-20 lg:px-14">
        <Typography variant="h4" className="text-xl md:text-2xl">
          성경적 영어교육은 이렇게 다릅니다!
        </Typography>
        <Typography variant="h6" className="font-normal">
          실제 젭스를 하고 계신 분들의 생생한 후기
        </Typography>
        <Cards items={HOME_REVIEW_DATA} />
        <Link to="/review">
          <Button
            variant="text"
            className="border-purple-00 mx-auto mt-6 block border"
          >
            <Typography
              variant="h6"
              className="text-purple-05 text-center font-semibold"
            >
              후기 더보기
            </Typography>
          </Button>
        </Link>
      </section>

      <section className="m-auto mt-[80px] max-w-[1440px] px-5 lg:px-14">
        <Typography variant="h4" className="text-xl md:text-2xl">
          클래스를 개설하여 자녀/학생들과 수업을 시작하세요.
        </Typography>
        {/* <TagCards gubun="homeschool" /> */}
        <div className="mt-6">
          <CourseList
            productSubType={ProductSubType.HOMESCHOOL}
            max={4}
            isFromMainPage={true}
          />
        </div>
        <Link to="/courses/homeschool">
          <Button
            variant="text"
            className="border-purple-00 mx-auto mt-6 block border"
          >
            <Typography
              variant="h6"
              className="text-purple-05 text-center font-semibold"
            >
              영어교실 전체보기
            </Typography>
          </Button>
        </Link>
      </section>

      <section className="m-auto mt-[80px] max-w-[1440px] px-5 lg:px-14">
        <Typography variant="h4" className="text-xl md:text-2xl">
          우리 교회에 영어주일학교를 도입하세요.
        </Typography>
        {/* <TagCards gubun="churchschool" /> */}
        <div className="mt-6">
          <CourseList
            productSubType={ProductSubType.WORSHIP}
            max={4}
            isFromMainPage={true}
          />
        </div>
        <Link to="/courses/churchschool">
          <Button
            variant="text"
            className="mx-auto block border border-purple5"
          >
            <Typography
              variant="h6"
              className="text-purple-05 text-center font-semibold"
            >
              주일학교 코스 전체보기
            </Typography>
          </Button>
        </Link>
      </section>
      <section className="m-auto mt-[80px] bg-[#6d10fe]">
        <div className="m-auto max-w-[375px] items-center p-7 pt-0">
          <div className="flex flex-col items-center">
            <img
              className="object-cover"
              alt="Image"
              src={process.env.PUBLIC_URL + 'images/home/main_jebstory.png'}
            />
          </div>
          <Link to="/story">
            <div className="bg-white p-4 text-center hover:bg-gray2">
              <Typography
                variant="h5"
                color="deep-purple"
                className="whitespace-nowrap text-center font-bold leading-6 tracking-tight"
              >
                젭스 자세히 알아보기
              </Typography>
            </div>
          </Link>
        </div>
      </section>
    </Fragment>
  );
};

export default Home;
